/**
 * Init data methods
 */
const EA = {
    Methods: {},
    loadMethod (methodName, context) {
        try {
            EA.Methods[methodName](context);
        } catch (e) {
            console.error(methodName, e);
            console.warn('EA.Method is not included properly. Check if the EA.method is imported in the app.js. Check if the EA.method name is correct in the method js file, app.js and html property "data-method".');
        }
    },
    loadMethods () {
        const elems = document.querySelectorAll('*[data-method]');
        elems.forEach(el => {
            const methods = el.getAttribute('data-method').split('|');
            methods.forEach(method => this.loadMethod(method.trim(), el));
        });
    }
};

export default EA;
